<template>
    <v-layout justify-center>
        <v-dialog v-model="show" persistent width="700px" :fullscreen="true">
            <v-toolbar dark color="blue lighten-2">
                <v-btn icon dark @click="show = false">
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>{{orderModel.title}}</v-toolbar-title>
                <v-toolbar-title>{{order.title}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="save">
                        <v-icon>save</v-icon>
                        {{orderModel.id === null ? ' Создать' : ' Сохранить'}}
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-list subheader class="content">
                <v-container>
                    <v-row>
                        <v-col >
                            <v-card height="100%">
                                <v-card-title class="py-1">Основная информация</v-card-title>
                                <v-card-text>
                                    <v-text-field
                                            hide-details
                                            readonly
                                            label="Сформирован"
                                            :value="getDateOutUnixTime(orderModel.created_at) + ' ' + getTimeOutUnixTime(orderModel.created_at)"
                                    />
                                    <v-select
                                            hide-details
                                            :items="statusesForThis"
                                            v-model="orderModel.status"
                                            label="Статус заказа"
                                            @change="changeStatus"
                                    />
                                    <v-select
                                            hide-details
                                            :items="payedForThis"
                                            v-model="orderModel.payed"
                                            label="Статус заказа"
                                            @change="changePayed"
                                    />
                                    <v-text-field
                                            hide-details
                                            v-model="orderModel.description"
                                            label="Комментарий"
                                    />
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col>
                            <v-card height="100%">
                                <v-card-title class="py-1"><a :href="clientUrl" style="text-decoration: none;" target="_blank">Покупатель {{nowClient ? nowClient.user_id : ''}}</a></v-card-title>
                                <v-card-text>
                                    <v-text-field
                                            hide-details
                                            readonly
                                            label="Id"
                                            :value="nowClient ? nowClient.id : ''"
                                    />
                                    <v-text-field
                                            hide-details
                                            readonly
                                            label="Имя"
                                            :value="nowClient ? nowClient.first_name : ''"
                                    />
                                    <v-text-field
                                            readonly
                                            hide-details
                                            label="Фамилия"
                                            :value="nowClient ? nowClient.last_name : ''"
                                    />
                                    <v-text-field
                                            readonly
                                            hide-details
                                            label="Никнейм"
                                            :value="nowClient ? nowClient.username : ''"
                                    />
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col>
                            <v-card>
                                <v-card-title class="py-1">Сведения о доставке</v-card-title>
                                <v-card-text>
                                    <v-text-field
                                            readonly
                                            hide-details
                                            label="Название доставки"
                                            :value="nowDelivery ? nowDelivery.title : ''"
                                    />
                                    <v-text-field
                                            hide-details
                                            label="Покупатель"
                                            v-model="orderModel.buyer_name"
                                    />
                                    <v-text-field
                                            hide-details
                                            label="Телефон"
                                            v-model="orderModel.buyer_phone"
                                    />
                                    <v-text-field
                                            hide-details
                                            label="Адрес"
                                            v-model="orderModel.address"
                                    />
                                    <v-text-field
                                            hide-details
                                            label="Время"
                                            v-model="orderModel.date"
                                    />
                                    <v-text-field
                                            hide-details
                                            label="Время"
                                            v-model="orderModel.time"
                                    />
                                    <v-text-field
                                            hide-details
                                            label="Гос. номер"
                                            v-model="orderModel.car_number"
                                    />
                                    <v-text-field
                                            hide-details
                                            label="Модель"
                                            v-model="orderModel.car_model"
                                    />
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <offer-table
                                :order-model="orderModel"
                                :delivery="nowDelivery"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-list>
        </v-dialog>

        <v-snackbar
                v-model="snackbarParams.show"
                bottom
                :color="snackbarParams.color"
                right
        >
            {{snackbarParams.text}}
            <v-btn
                    dark
                    text
                    @click="snackbarParams.show = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import timeHelpers from '../../../scripts/helpers/timeHelpers'
import OfferTable from './OfferTable'
import constConf from '../../../constconf'
export default {
    name: 'OrderForm',
    components: {
        OfferTable
    },
    props: ['orderFormShow', 'orderId', 'statuses', 'payed'],
    data() {
        return {
            show: false,
            snackbarParams: {
                show: false,
                color: 'success',
                text: 'Успешно сохранено!'
            },
            orderModel: {
                id: null,
                delivery_id: null
            },
            ...constConf
        }
    },
    watch: {
        orderFormShow: {
            handler(value) {
                if (value) {
                    this.loadModel()
                    this.show = value
                    if (this.$route.path !== '/bot' + this.$route.params['pathMatch'] + '/order/' + this.orderId) {
                        this.$router.push({ path: '/bot' + this.$route.params['pathMatch'] + '/order/' + this.orderId })
                    }
                } else {
                    if (this.$route.path !== '/bot' + this.$route.params.pathMatch + '/order') {
                        this.$router.push({ path: '/bot' + this.$route.params.pathMatch + '/order' })
                    }
                }
            },
            deep: false,
            immediate: false
        },
        show(value) {
            if (!value) {
                this.$emit('close')
            }
        }
    },
    methods: {
        save() {
            this.$store.dispatch('cards/cardCreate', this.orderModel).then(response => {
                if (response.ok) {
                    this.snackbarParams.text = 'Успешно сохранено!'
                    this.snackbarParams.color = 'success'
                    this.snackbar = true
                }
            })
        },
        loadModel() {
            this.orderModel = Object.assign({}, this.order(this.orderId))
        },
        ...timeHelpers,
        changeStatus() {
            this.$store.dispatch('cards/changeStatus', { orderId: this.orderModel.id, status: this.orderModel.status }).then(response => {
                if (response.ok) {
                    this.snackbarParams.text = 'Статус успешно изменен!'
                    this.snackbarParams.color = 'success'
                    this.snackbarParams.show = true
                }
            })
        },
        changePayed() {
            this.$store.dispatch('cards/changePayed', { orderId: this.orderModel.id, status: this.orderModel.payed }).then(response => {
                if (response.ok) {
                    this.snackbarParams.text = 'Статус успешно изменен!'
                    this.snackbarParams.color = 'success'
                    this.snackbarParams.show = true
                }
            })
        }
    },
    computed: {
        ...mapGetters({
            order: 'cards/getOrderById',
            getClientByUserId: 'clients/getClientByUserId',
            getDeliveryById: 'cards/getDeliveryById',
            clients: 'clients/clients'
        }),
        nowClient() {
            return this.orderModel ? this.getClientByUserId(this.orderModel.user_id) : null
        },
        nowDelivery() {
            return this.orderModel && this.orderModel.delivery_id != null ? this.getDeliveryById(this.orderModel.delivery_id) : null
        },
        statusesForThis() {
            let statuses = this.statuses
            /* for (let i = 1; i <= this.statuses.length - 1; i++) {
                statuses.push(this.statuses[i])
            } */
            statuses.splice(0, 1)
            return statuses
        },
        payedForThis() {
            let payed = []
            for (let i = 1; i <= this.payed.length - 1; i++) {
                payed.push(this.payed[i])
            }
            return payed
        },
        clientUrl() {
            if (this.orderModel !== undefined) {
                return '/bot' + this.$route.params['pathMatch'] + '/client/' + this.orderModel.user_id
            } else {
                return ''
            }
        }
    }
}
</script>

<style scoped>

</style>
